<template>
  <o-view class="c-view--poi" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        :has-back-button="true"
        :is-centered="true"
        :is-extended="true"
        logo="brands/cambio"
      >
        <template slot="right">
          <o-icon icon="favorite" v-if="$store.state.showFavoriteButton" />
        </template>
      </o-nav-bar>
      <div class="c-view--poi-sections">
        <o-section :is-transparent="true" :poi-header="true">
          <h2 class="c-poi-title">Gent-Dampoort</h2>
        </o-section>
        <o-block-list title="Beschikbare wagenklasses">
          <o-section>XS Cargobike</o-section>
          <o-section>S Micro - 2 + 2 pl.</o-section>
          <o-section> S Micro autom. - 2 + 2 pl.</o-section>
          <o-section>S Mini</o-section>
          <o-section>S Mini autom.</o-section>
          <o-section>S e-cambio autom.</o-section>
        </o-block-list>
        <o-block-list>
          <o-list-item icon="info" label="Info standplaats" />
        </o-block-list>
      </div>
    </o-view>
    <o-pay-button label="Reserveer wagen" to="/sales/car/cambio" />
  </o-view>
</template>

<script>
import OPayButton from '@/components/OPayButton.vue'
import OProminents from '@/components/OProminents.vue'
export default {
  name: 'POICambio',
  components: {
    OPayButton,
    OProminents
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss">
.c-view--poi {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .c-view--poi-sections {
    flex: 1 0 auto;
  }
}

.c-poi-title {
  font-weight: 600;
  text-align: center;
}

.c-poi-available {
  color: #000;
  font-weight: 600;

  .c-icon {
    color: $primary-color;
    color: var(--primary-color);
  }
}
</style>
